// Re-fetch a poll every `intervalMs` while the tab is visible ("Results update
// live"). Pauses when hidden, refreshes once on becoming visible again.
import { useEffect, useRef } from 'react';

export default function useLivePoll(enabled, refresh, intervalMs = 10000) {
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    const visible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden';
    const start = () => {
      if (timer == null) timer = setInterval(() => { if (visible()) refreshRef.current(); }, intervalMs);
    };
    const stop = () => {
      if (timer != null) { clearInterval(timer); timer = null; }
    };
    const onVisibility = () => {
      if (visible()) { refreshRef.current(); start(); } else { stop(); }
    };
    if (visible()) start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [enabled, intervalMs]);
}
